// components/common/RevealSection.jsx
import { motion } from "framer-motion";

function RevealSection({ children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true, amount: 0.3 }} // chỉ chạy 1 lần khi vào view
    >
      {children}
    </motion.div>
  );
}

export default RevealSection;
